export default "/static/img/layers/osm-wms.db57d0686e01c93fb115520714fdc7c8.png";